export const SESSION_KEY = 'approximate-grid-session';
export const USERNAME_KEY = 'approximate-grid-username';
export const PLAYED_KEY = 'approximate-grid-played';
